module.exports = __webpack_public_path__ + "img/franchising_hero_cake3.b1ef3854.png";